'use client'

import * as React from 'react'
import { Tooltip as TooltipPrimitive } from 'radix-ui'

import { cn } from '@/utils'
import { TooltipArrow } from '@/icons'

const TooltipProvider = TooltipPrimitive.Provider

const Tooltip = TooltipPrimitive.Root

const TooltipTrigger = TooltipPrimitive.Trigger

type TooltipContentProps = React.ComponentPropsWithRef<
  typeof TooltipPrimitive.Content
> & {
  arrow?: boolean
}

const TooltipContent = ({
  className,
  sideOffset = 4,
  children,
  arrow = true,
  ...props
}: TooltipContentProps) => (
  <TooltipPrimitive.Portal>
    <TooltipPrimitive.Content
      sideOffset={sideOffset}
      className={cn(
        'px-3xs py-nano text-2xs data-[state=closed]:animate-out data-[state=closed]:fade-out data-[state=closed]:data-[side=bottom]:slide-out-to-top-[2px] data-[state=closed]:data-[side=left]:slide-out-to-right-[2px] data-[state=closed]:data-[side=right]:slide-out-to-left-[2px] data-[state=closed]:data-[side=top]:slide-out-to-bottom-[2px] data-[state=delayed-open]:animate-in data-[state=delayed-open]:fade-in data-[state=delayed-open]:data-[side=bottom]:slide-in-from-top-[2px] data-[state=delayed-open]:data-[side=left]:slide-in-from-right-[2px] data-[state=delayed-open]:data-[side=right]:slide-in-from-left-[2px] data-[state=delayed-open]:data-[side=top]:slide-in-from-bottom-[2px] data-[state=open]:data-[side=right]:slide-in-from-left-[2px] data-[state=open]:data-[side=top]:slide-in-from-bottom-[2px] z-50 select-none rounded-md bg-black/65 text-white shadow-md will-change-[transform,opacity]',
        className,
      )}
      {...props}
    >
      {children}
      {arrow && (
        <TooltipPrimitive.Arrow
          asChild
          width="16"
          height="10"
          className="h-2.5 w-4 text-black/65"
        >
          <TooltipArrow viewBox="0 0 16 10" />
        </TooltipPrimitive.Arrow>
      )}
    </TooltipPrimitive.Content>
  </TooltipPrimitive.Portal>
)
TooltipContent.displayName = TooltipPrimitive.Content.displayName

export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider }
